<script lang="ts">
	import Icon from '../../icon/Icon.svelte'
	import { _ } from '@repo/i18n'
	import { Action } from '@repo/ui'
	import { XMark } from '@steeze-ui/heroicons'
	import { createEventDispatcher } from 'svelte'

	interface Props {
		disabled?: boolean
		customColor?: string
		children?: import('svelte').Snippet
	}

	let { disabled = false, customColor = null, children }: Props = $props()

	const dispatch = createEventDispatcher()

	function handleRemove() {
		dispatch('remove')
	}
</script>

<div
	style:background-color={customColor}
	class="
    inline-flex items-center rounded px-2 py-1
    {disabled ? 'border-primary-500 text-primary-500 border bg-white' : 'bg-primary-500 text-white'}
  "
>
	{@render children?.()}

	{#if !disabled}
		<div class="ml-1"></div>
		<Action
			name="remove-selected-option"
			ariaLabel={$_('button.remove')}
			onclick={handleRemove}
			stopPropagation
		>
			<Icon small src={XMark} />
		</Action>
	{/if}
</div>
